import { I18N } from '@gravity-ui/i18n';
import { Lang, getConfig, subscribeConfigure } from './configure';
export var i18n = new I18N();
export function getLang() {
  return getConfig().lang || Lang.Ru;
}
export function setLang(lang) {
  i18n.setLang(lang);
}
export function has(keysetName, key) {
  return i18n.has(keysetName, key, getLang());
}
i18n.setLang(getLang());
subscribeConfigure(function (config) {
  if (config.lang) {
    i18n.setLang(config.lang);
  }
});
// #sourceMappingURL=i18n.js.map